import {
  tooltipPlacement,
  TooltipTrigger,
} from "@visiblethread/react-components";
import clsx from "clsx";
import { ListChevronsDownUpIcon, ListChevronsUpDownIcon } from "lucide-react";
import {
  element,
  func,
  number,
  object,
  oneOfType,
  shape,
  string,
} from "prop-types";
import { isValidElement, useContext } from "react";

import ExcelTableContext from "./ExcelTableContext";
import classes from "./HeaderCell.module.scss";

const HeaderCell = ({ colIndex, editKey, header, table }) => {
  const { expandableColumnIndex, isEditing: isEditingTable } =
    useContext(ExcelTableContext);
  const isExpandableCell = expandableColumnIndex === colIndex;
  const isEditableColumn = isEditingTable && Boolean(editKey);
  const toggleAllHandler = table.getToggleAllRowsExpandedHandler();
  const areAllExpanded = table.getIsAllRowsExpanded();
  const content = areAllExpanded ? "Collapse all" : "Expand all";
  const ToggleIcon = areAllExpanded
    ? ListChevronsDownUpIcon
    : ListChevronsUpDownIcon;

  const onClickToggleAll = (e) => {
    e.stopPropagation();
    e.preventDefault();
    toggleAllHandler(e);
  };

  return (
    <div
      className={clsx(classes["header_cell"], {
        [classes["header_cell--editing"]]: isEditingTable,
        [classes["header_cell--editable_col"]]: isEditableColumn,
        [classes["header_cell--expandable"]]: isExpandableCell,
      })}
    >
      {isExpandableCell && (
        <TooltipTrigger
          classes={classes.tooltip}
          tooltipStyle={{ overflow: "visible" }}
          content={content}
          placement={tooltipPlacement.top}
        >
          <button
            className={classes["header_cell__expand_all"]}
            onClick={onClickToggleAll}
          >
            <ToggleIcon size={16} />
          </button>
        </TooltipTrigger>
      )}

      {isValidElement(header) ? header : <div>{header}</div>}
    </div>
  );
};

HeaderCell.propTypes = {
  colIndex: number,
  editKey: oneOfType([func, string]),
  header: oneOfType([element, string, object]),
  table: shape({
    getToggleAllRowsExpandedHandler: func,
  }),
};

export default HeaderCell;
